import Api from '@/api/api.js'

export default {
    saveDHIS2Diagnostic(data) {
        const promise = Api().post('/dhis2/diagnostic/store', data)
        return promise.then(response => response.data)
    },

    getDHIS2Diagnostic(data) {
        const promise = Api().post('/dhis2/consultation/dhis2-diagnostic', data)
        return promise.then(response => response.data)
    },

    deleteConsultationDHIS2Diagnostic(data) {
        const promise = Api().post('/dhis2/consultation/delete-dhis2-diagnostic', data)
        return promise.then(response => response.data)
    },

    getStatConsultationDHIS2(data) {
        const promise = Api().post('/dhis2/statistique', data)
        return promise.then(response => response.data)
    },

    sendStatConsultationDHIS2(data) {
        const promise = Api().post('/dhis2/send/statistique', data)
        return promise.then(response => response.data)
    },
}